import React from "react";
import type { MailAnsicht } from "./mailAnsicht";
import { useMailAnsicht } from "./useMailAnsicht";
import "./mailSettings.css";

/**
 * T-29 — Reiter „Darstellung" im Mail-Einstellungsfenster: Unterhaltungen oder
 * einzelne Mails, mit ausführlicher Erklärung.
 *
 * T-61: Das ist die EINZIGE Stelle, an der die Darstellung gewählt wird — den
 * Schalter „Anzeigen als" in der Funktionsleiste der Mail-App gibt es nicht
 * mehr. Die Wahl hängt weiter am gemeinsamen Stand (`useMailAnsicht`) und
 * schaltet die offene Mail-App sofort um, ohne Neuladen.
 */
const OPTIONEN: { wert: MailAnsicht; titel: string; erklaerung: string }[] = [
    {
        wert: "unterhaltungen",
        titel: "Unterhaltungen",
        erklaerung:
            "Antworten zu einer Mail werden zusammengefasst. Eine Mail und alle Antworten darauf stehen in einer Zeile; beim Öffnen sehen Sie den ganzen Verlauf untereinander.",
    },
    {
        wert: "einzeln",
        titel: "Einzelne Mails",
        erklaerung:
            "Jede Mail steht in einer eigenen Zeile, auch jede Antwort. Beim Öffnen sehen Sie nur diese eine Mail.",
    },
];

export const MailAnsichtSection: React.FC = () => {
    const { ansicht, setAnsicht } = useMailAnsicht();
    return (
        <div className="mset mset-card">
            <h2 className="mset-title" id="mset-ansicht-titel">
                Darstellung im Posteingang
            </h2>
            <div role="radiogroup" aria-labelledby="mset-ansicht-titel">
                {OPTIONEN.map((o) => (
                    <label
                        key={o.wert}
                        className="mset-radio"
                        style={{ alignItems: "flex-start", padding: "6px 0" }}
                    >
                        <input
                            type="radio"
                            name="mail-ansicht"
                            value={o.wert}
                            checked={ansicht === o.wert}
                            onChange={() => setAnsicht(o.wert)}
                            style={{ marginTop: 3 }}
                        />
                        <span>
                            <span style={{ fontWeight: 600 }}>{o.titel}</span>
                            <span className="mset-hint" style={{ display: "block", marginTop: 2 }}>
                                {o.erklaerung}
                            </span>
                        </span>
                    </label>
                ))}
            </div>
            <div className="mset-hint mset-block">
                Die Wahl gilt sofort für alle Ordner Ihrer Mail-Übersicht und wird für Sie gespeichert.
            </div>
        </div>
    );
};
